module.exports = require("swa-bootstrap-corporate-landing-home-page/login-update-customer-information-data");